<template>
  <div>
    <Navbar />

    <section class="contact-page">
      <div class="contact-shell">

        <!-- Left: Company info -->
        <aside class="contact-info-panel">
          <p class="info-kicker">Norland Advisory</p>
          <h2 class="info-heading">Your Portfolio<br>Partner</h2>
          <p class="info-tagline">We help everyday Australians build long-term wealth through strategic property investment. Book a free 15-minute discovery call and let's start the conversation.</p>

          <div class="info-list">
            <div class="info-item">
              <span class="info-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </span>
              <div>
                <p class="info-label">Email</p>
                <a href="mailto:info@norlandproperty.com.au" class="info-value">info@norlandproperty.com.au</a>
              </div>
            </div>

            <div class="info-item">
              <span class="info-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </span>
              <div>
                <p class="info-label">Address</p>
                <p class="info-value">Level 6, 21 Ellingworth Parade<br>Box Hill VIC 3128</p>
              </div>
            </div>

            <div class="info-item">
              <span class="info-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="2" y="7" width="20" height="14" rx="2" />
                  <path d="M16 3H8a2 2 0 0 0-2 2v2h12V5a2 2 0 0 0-2-2z" />
                </svg>
              </span>
              <div>
                <p class="info-label">ABN</p>
                <p class="info-value">88 676 745 538</p>
              </div>
            </div>
          </div>

          <!-- <div class="info-badges">
            <span class="info-badge">Licensed Real Estate Agency</span>
            <span class="info-badge">Melbourne, Victoria</span>
          </div> -->
        </aside>

        <!-- Right: Discovery Call form -->
        <div class="contact-form-panel">
          <div class="form-header">
            <span class="form-pill">Free · 15 Minutes</span>
            <h1>Book a Discovery Call</h1>
            <p>Fill in your details below and our team will reach out to schedule a call at a time that works for you.</p>
          </div>

          <form class="discovery-form" @submit.prevent="submitForm">
            <div class="form-row">
              <label class="form-field">
                <span>Full Name <span class="req">*</span></span>
                <input v-model.trim="form.name" type="text" placeholder="Your full name" required />
              </label>
              <label class="form-field">
                <span>Phone <span class="req">*</span></span>
                <input v-model.trim="form.phone" type="tel" placeholder="e.g. 0400 000 000" required />
              </label>
            </div>

            <label class="form-field">
              <span>Email <span class="req">*</span></span>
              <input v-model.trim="form.email" type="email" placeholder="name@email.com" required />
            </label>

            <div class="form-row">
              <label class="form-field">
                Best Time to Call
                <select v-model="form.callTime">
                  <option value="">No preference</option>
                  <option>Morning (9am – 12pm)</option>
                  <option>Afternoon (12pm – 5pm)</option>
                  <option>Evening (5pm – 8pm)</option>
                </select>
              </label>
              <label class="form-field">
                Investment Budget
                <select v-model="form.budget">
                  <option value="">Prefer not to say</option>
                  <option>Under $500K</option>
                  <option>$500K – $800K</option>
                  <option>$800K – $1.2M</option>
                  <option>$1.2M – $2M</option>
                  <option>$2M+</option>
                </select>
              </label>
            </div>

            <label class="form-field">
              Your Enquiry
              <textarea v-model.trim="form.enquiry" rows="4" placeholder="Tell us about your goals, current situation, or any questions you have..."></textarea>
            </label>

            <div v-if="state.error" class="form-error">{{ state.error }}</div>

            <button type="submit" class="form-submit" :disabled="state.submitting">
              <span v-if="state.submitting">Sending…</span>
              <span v-else>Send Request</span>
            </button>
          </form>

          <div v-if="state.success" class="form-success">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <polyline points="9 12 11 14 15 10" />
            </svg>
            <div>
              <strong>Request received!</strong>
              <p>Thank you, {{ state.submittedName }}. Our team will contact you shortly to confirm your discovery call.</p>
            </div>
          </div>
        </div>

      </div>
    </section>

    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from '@/components/layout/SiteFooter.vue'
import Navbar from '@/components/layout/Navbar.vue'
import { pubStoreSpecAction } from '@/api/apiService'
import env from '@/api/env'

const storeId = env.storeId

export default {
  components: { SiteFooter, Navbar },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        callTime: '',
        budget: '',
        enquiry: ''
      },
      state: {
        submitting: false,
        success: false,
        error: '',
        submittedName: ''
      }
    }
  },
  methods: {
    async submitForm() {
      if(!this.form.name || !this.form.phone || !this.form.email) {
        this.state.error = 'Please fill in your name, phone and email.'
        return
      }
      this.state.error = ''
      this.state.submitting = true
      try {
        await pubStoreSpecAction(storeId, 'submitClientReq', {
          type: 'callback',
          name: this.form.name,
          phone: this.form.phone,
          email: this.form.email,
          callTime: this.form.callTime,
          budget: this.form.budget,
          enquiry: this.form.enquiry
        })
      } catch(e) {
        // best-effort; proceed to success regardless
      } finally {
        this.state.submitting = false
      }
      this.state.submittedName = this.form.name
      this.state.success = true
      this.form = { name: '', phone: '', email: '', callTime: '', budget: '', enquiry: '' }
    }
  }
}
</script>

<style scoped>
.contact-page {
  padding: 118px 5% 80px;
  min-height: 100vh;
  background:
    radial-gradient(circle at 8% 14%, rgba(140, 193, 179, 0.14), transparent 32%),
    radial-gradient(circle at 90% 82%, rgba(96, 149, 136, 0.12), transparent 28%),
    #f2f7f5;
  --c-primary: #2f7a6c;
  --c-primary-deep: #1e5f53;
  --c-accent: #7bb5a8;
  --c-accent-soft: #b8dcd4;
  --c-text-strong: #2f4c45;
  --c-text-body: #5e7972;
  --c-text-muted: #7b918b;
  --c-card-border: #d2e3de;
  --c-on-dark: #edf8f5;
}

.contact-shell {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(300px, 0.85fr) minmax(0, 1.15fr);
  gap: 36px;
  align-items: start;
}

/* ── Left panel ── */
.contact-info-panel {
  border-radius: 20px;
  padding: 36px 32px;
  background: linear-gradient(150deg, #0f5d53 0%, #0a3d35 100%);
  color: var(--c-on-dark);
  display: grid;
  gap: 0;
}

.info-kicker {
  margin: 0 0 8px;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--c-accent-soft);
}

.info-heading {
  margin: 0 0 14px;
  font-size: clamp(1.8rem, 3vw, 2.6rem);
  font-weight: 700;
  line-height: 1.1;
  color: #f2fcf8;
}

.info-tagline {
  margin: 0 0 32px;
  color: rgba(237, 248, 245, 0.82);
  line-height: 1.7;
  font-size: 0.97rem;
}

.info-list {
  display: grid;
  gap: 20px;
  margin-bottom: 32px;
}

.info-item {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.info-icon {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(193, 232, 222, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2px;
}

.info-icon svg {
  width: 18px;
  height: 18px;
  color: var(--c-accent-soft);
}

.info-label {
  margin: 0 0 4px;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(184, 220, 212, 0.8);
}

.info-value {
  margin: 0;
  color: #e8f9f4;
  font-size: 0.95rem;
  line-height: 1.55;
  text-decoration: none;
  font-weight: 500;
}

a.info-value:hover {
  color: #ffffff;
  text-decoration: underline;
}

.info-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.info-badge {
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 0.76rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--c-accent-soft);
  border: 1px solid rgba(184, 220, 212, 0.35);
  background: rgba(255, 255, 255, 0.08);
}

/* ── Right panel ── */
.contact-form-panel {
  background: #ffffff;
  border-radius: 20px;
  padding: 36px 36px 32px;
  border: 1px solid var(--c-card-border);
  box-shadow: 0 18px 40px rgba(26, 62, 49, 0.08);
}

.form-header {
  margin-bottom: 28px;
}

.form-pill {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--c-primary);
  background: #e6f4f1;
  border: 1px solid #c3deda;
  margin-bottom: 12px;
}

.form-header h1 {
  margin: 0 0 8px;
  font-size: clamp(1.5rem, 2.8vw, 2rem);
  color: var(--c-text-strong);
  line-height: 1.2;
}

.form-header p {
  margin: 0;
  color: var(--c-text-body);
  font-size: 0.97rem;
  line-height: 1.6;
}

.discovery-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--c-text-strong);
}

.req {
  color: #c0392b;
}

.form-field input,
.form-field select,
.form-field textarea {
  border: 1px solid var(--c-card-border);
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.95rem;
  color: var(--c-text-strong);
  background: #f9fcfb;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  font-family: inherit;
  width: 100%;
  box-sizing: border-box;
}

.form-field input:focus,
.form-field select:focus,
.form-field textarea:focus {
  border-color: var(--c-primary);
  box-shadow: 0 0 0 3px rgba(47, 122, 108, 0.14);
}

.form-field textarea {
  resize: vertical;
  min-height: 96px;
}

.form-error {
  font-size: 0.88rem;
  color: #c0392b;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fdf2f2;
  border: 1px solid #f5c6cb;
}

.form-submit {
  margin-top: 4px;
  padding: 13px 20px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #3c9d87 0%, #2d7463 100%);
  color: #f2fcf8;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  cursor: pointer;
  transition: filter 0.2s, transform 0.15s;
}

.form-submit:hover:not(:disabled) {
  filter: brightness(1.07);
  transform: translateY(-1px);
}

.form-submit:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.form-success {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-top: 20px;
  padding: 18px 20px;
  border-radius: 14px;
  background: #edf8f3;
  border: 1px solid #a8d9c8;
  color: var(--c-text-strong);
}

.form-success svg {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  color: var(--c-primary);
  margin-top: 1px;
}

.form-success strong {
  display: block;
  font-size: 1rem;
  color: var(--c-primary-deep);
  margin-bottom: 4px;
}

.form-success p {
  margin: 0;
  font-size: 0.92rem;
  color: var(--c-text-body);
  line-height: 1.5;
}

@media (max-width: 1024px) {
  .contact-shell {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .contact-page {
    padding: 106px 4% 60px;
  }

  .contact-info-panel {
    padding: 28px 22px;
  }

  .contact-form-panel {
    padding: 28px 22px 24px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}
</style>


<style scoped>
.contact-page {
  padding: 220px 4% 88px;
  background:
    radial-gradient(circle at 10% 18%, rgba(140, 193, 179, 0.16), transparent 32%),
    radial-gradient(circle at 88% 82%, rgba(96, 149, 136, 0.14), transparent 28%),
    #f2f7f5;
}

.contact-shell {
  max-width: 1220px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(320px, 0.92fr) minmax(0, 1.08fr);
  gap: 34px;
  align-items: start;
}

.contact-info-panel {
  border-radius: 10px;
  background: linear-gradient(160deg, #0f5d53 0%, #0f4c43 100%);
  padding: 20px;
}

.info-inner {
  border-radius: 8px;
  background: #f2f2f2;
  padding: 10px 18px;
}

.info-row {
  display: grid;
  grid-template-columns: 56px 1fr;
  gap: 12px;
  align-items: start;
  padding: 18px 0;
  border-bottom: 1px solid #dfdfdf;
}

.info-row-last {
  border-bottom: none;
}

.icon-dot {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #e8f4f0;
  color: #4b8f80;
  display: grid;
  place-items: center;
  font-size: 0.95rem;
  font-weight: 700;
}

.info-row p {
  margin: 2px 0 8px;
  color: #607278;
  font-size: 1.02rem;
}

.info-row h4 {
  margin: 0;
  color: #2d4f56;
  font-size: 1.95rem;
  font-weight: 500;
  line-height: 1.35;
}

.social-row {
  padding: 16px 8px 10px;
  display: flex;
  gap: 12px;
  justify-content: center;
}

.social-row a {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  color: #eaf7f3;
  text-decoration: none;
  font-weight: 700;
  display: grid;
  place-items: center;
}

.contact-right-panel h1 {
  margin: 18px 0 12px;
  color: #295f54;
  font-size: clamp(2.1rem, 4vw, 3.6rem);
  line-height: 1.14;
}

.contact-right-panel h1 span {
  color: #5da294;
}

.contact-right-panel p {
  margin: 0;
  color: #6d6d6d;
  font-size: 1.25rem;
  line-height: 1.7;
}

.qr-wrap {
  margin-top: 22px;
  width: min(360px, 100%);
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dcdcdc;
}

.qr-wrap img {
  width: 100%;
  display: block;
}

.contact-right-panel h3 {
  margin: 16px 0 0;
  color: #7b7b7b;
  font-size: 3.2rem;
  font-weight: 400;
}

.contact-right-panel h3 span {
  color: #5f5f5f;
  font-weight: 500;
}

@media (max-width: 1024px) {
  .contact-shell {
    grid-template-columns: 1fr;
    gap: 22px;
  }

  .contact-right-panel h3 {
    font-size: 2.3rem;
  }
}

@media (max-width: 768px) {
  .contact-page {
    padding: 160px 4% 56px;
  }

  .contact-info-panel {
    padding: 14px;
  }

  .info-inner {
    padding: 6px 14px;
  }

  .info-row {
    grid-template-columns: 46px 1fr;
    gap: 10px;
    padding: 14px 0;
  }

  .icon-dot {
    width: 42px;
    height: 42px;
    font-size: 0.75rem;
  }

  .info-row p {
    font-size: 0.95rem;
  }

  .info-row h4 {
    font-size: 1.2rem;
    color: #234d55;
    font-weight: 600;
  }

  .contact-right-panel h1 {
    margin-top: 0;
    color: #234f45;
    line-height: 1.18;
  }

  .contact-right-panel h1 span {
    color: #3f897a;
  }

  .contact-right-panel p {
    font-size: 1.05rem;
    color: #4f6f67;
    font-weight: 500;
  }

  .contact-right-panel h3 {
    font-size: 1.7rem;
    color: #57756e;
  }

  .contact-right-panel h3 span {
    color: #2f5d54;
  }

  .social-row a {
    background: rgba(255, 255, 255, 0.24);
    border: 1px solid rgba(234, 247, 243, 0.52);
  }
}
</style>
